<template>
  <div class="pdf-viewer-content"><pdf v-for="i in numPages" :key="i" class="pdf-viewer" :src="src" :page="i"></pdf></div>
</template>

<style scoped>
.pdf-viewer-content {
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  justify-items: stretch;
  align-items: center;
}
.pdf-viewer{
  margin: auto;
  width: 100%;
}
</style>

<script>
import pdf from 'vue-pdf'

export default {
  data() {
    return {
      src: '/assets/pdf/politica-de-privacidade.pdf',
      numPages: 14,
    }
  },
  components: {
    pdf,
  },
}
</script>
